import React, { useCallback } from 'react'
import { Icon } from 'util/ui'

export default function LinkedGitHubIssuesRow({
  doNavigatableSetState,
  issue,
  issue: { loaded, repository: { nameWithOwner: repoName } = {}, title } = {},
}) {
  const onClick = useCallback(
    () => {
      doNavigatableSetState(issue.id)
    },
    [doNavigatableSetState, issue]
  )
  if (issue && loaded)
    return (
      <div className="LinkedGitHubIssuesRow" onClick={onClick}>
        <div className="titleAndSubTitleColumn">
          <div className="title">{title}</div>
          <div className="subTitle">{repoName}</div>
        </div>
        <div className="iconColumn">
          <Icon name="chevron right" />
        </div>
      </div>
    )
  return null
}
